

export const endsWithLetterA = (value) => {
  value = value.toLowerCase();
    if (value.charAt(value.length - 1) === 'a') {
      return true;
    } else {
      return false;
    }
  }